import { Component, Input, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { StudentQRCode } from '../data/student-qr-code';
import { BaseComponent } from '../base/base.component';
@Component({
  selector: 'app-print-qr-codes',
  templateUrl: './print-qr-codes.component.html',
  styleUrls: ['./print-qr-codes.component.css']
})
export class PrintQrCodesComponent extends BaseComponent implements OnInit {

  @Input() orgId?: number;
  @Input() studentCodes?: StudentQRCode[];
  @Input() hideButton: boolean = false;

  @ViewChild('outlet', {
    read: ViewContainerRef,
    static: false
  }) outletRef: ViewContainerRef;
  @ViewChild('content', {
    read: TemplateRef,
    static: false
  }) contentRef: TemplateRef<any>;

  loading: boolean = false;
  pages: StudentQRCode[][][] = [];
  columns: number = 4;
  rows: number = 2;

  targetId = 'qr-container';

  ngOnInit() {
    if (this.studentCodes && this.studentCodes.length > 0)
    {
      this.pages = [];
      this.makePages();
    }
    else if (this.orgId)
    {
      this.loading = true;
      this.dataService.getStudentQRCodes(this.orgId).subscribe(q => {
        this.studentCodes = q;
        this.loading = false;
        this.pages = [];
        this.makePages();
      })
    }
    else
    {
      this.studentCodes = [];
      this.pages = [];
      this.makePages();
    }
  }

  makePages() {
    var page: StudentQRCode[][] = [];
    var row: StudentQRCode[] = [];

    this.studentCodes.forEach(student => {
      row.push(student);

      if (row.length >= this.columns) {
        page.push(row);
        row = [];
      }

      if (page.length >= this.rows) {
        this.pages.push(page);
        page = [];
      }
    });

    if (row.length > 0) {
      page.push(row);
    }

    if (page.length > 0) {
      this.pages.push(page);
    }
  }

  getQRData(student: StudentQRCode): string {
    return `{ "JoyToken": "${student.JoyToken}" }`;
  }

  printDiv() {
    const tags = document.getElementById(this.targetId);
    let currentUrl = window.location.href;
    let printWindow = window.open();
    printWindow.location.href = currentUrl;
    
    // Enhanced print styling for consistent page breaks
    const printStyles = `
      <style>
        @page {
          size: 11in 8.5in landscape;
          margin: 0.4in;
        }
        body {
          margin: 0;
          padding: 0;
          font-family: 'Poppins', sans-serif;
        }
        .qr-page {
          height: 100vh;
          width: 100vw;
          page-break-after: always;
          page-break-inside: avoid;
          display: flex;
          flex-direction: column;
          padding: 0;
        }
        .qr-page:last-child {
          page-break-after: auto;
        }
        .qr-row {
          height: 50vh;
          width: 100vw;
          display: flex;
          flex-direction: row;
          flex: 1;
        }
        .qr-student-card {
          width: 25vw;
          height: 50vh;
          border: 1px dashed black;
          text-align: center;
          display: flex;
          justify-content: space-around;
          flex-direction: column;
          box-sizing: border-box;
          padding: 10px;
          page-break-inside: avoid;
          border-right: none;
        }
        .qr-student-card:last-child {
          border-right: 1px dashed black;
        }
        .qr-row:first-child .qr-student-card {
          border-bottom: none;
        }
        .qr-row:last-child .qr-student-card {
          border-bottom: 1px dashed black;
        }
        .qr-logo {
          margin-left: auto;
          margin-right: auto;
        }
        .qr-student-name {
          font-size: 24px;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          font-family: Poppins, sans-serif;
          font-weight: bold;
          margin: 5px 0;
        }
        .qr-class-name {
          font-size: 16px;
          font-family: Poppins, sans-serif;
          margin: 5px 0;
        }
      </style>
    `;
    
    printWindow.document.write(printStyles + "<body></body>");
    printWindow.document.title = "Joy School QR Codes";
    printWindow.document.body.appendChild(tags);
    printWindow.print();
    printWindow.close();
    this.outletRef.clear();
    this.outletRef.createEmbeddedView(this.contentRef);
  }
}
